import { useState } from 'react';
import clsx from 'clsx';

import { IXMLSidebarOldData } from 'utils/aws-s3-helper';
import { AccordionSidebarItem } from './accordion-sidebar-item';
import styles from './accordion-list.module.scss';

export interface IArchiveLink {
	title: string;
	href: any;
	description?: string;
}

export interface IAccordionSidebarGroupProps {
	slug?: string;
	groups: IXMLSidebarOldData[];
	link?: IArchiveLink;
}

export const AccordionSidebarGroup = ({ groups, slug, link }: IAccordionSidebarGroupProps): React.JSX.Element => {
	const [isOpen, setIsOpen] = useState<number>(groups.findIndex((group) => slug?.includes(group.year)));

	return (
		<ul>
			{groups.map((group, index) => (
				<li
					key={`year__${group.year}`}
					className={clsx(slug?.includes(group.year) && styles.active, isOpen === index && styles.open)}
				>
					<button
						type="button"
						onClick={() => setIsOpen(isOpen === index ? -1 : index)}
						aria-expanded={isOpen === index}
					>
						{group.year}
					</button>
					<div className={clsx(styles.group, isOpen === index && styles.open)}>
						{group.files && <AccordionSidebarItem files={group.files} slug={slug} />}
					</div>
				</li>
			))}
			{link?.href && link.title && (
				<li>
					<a href={link.href.url} target="_blank" rel="noreferrer noopener">
						{link.title}
					</a>
				</li>
			)}
		</ul>
	);
};

export default AccordionSidebarGroup;
